import React, { useState, useMemo, useEffect } from "react";
import axios from "axios";
import {
  CustomSelect,
} from "components/Input/Index.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { putGEBAutomation } from "services/ConfigServices";
import styled from "styled-components";
import { controltypeData, controllistData } from "variables/MBM/lists/equipments";
import { automationText } from "variables/MBM/geb"
import DateTimeInput from "components/Input/DateTimeInput";
import moment from "moment";
import 'moment/locale/fr';
import { NotificationManager } from "react-notifications";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters";
import SweetAlert from "react-bootstrap-sweetalert";
import HelpIcon from '@mui/icons-material/Help';
import DataTable from "react-data-table-component";
import IntInputUn from "components/Input/IntInputUn";
import TextInputUn from "components/Input/TextInputUn";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "65ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "65ch",
  },
  submitdelButton: {
    color: "#FFFFFF",
    backgroundColor: "#f44336",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "65ch",
    "&:hover": {
      backgroundColor: "#f44336",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitdelButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "65ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  icon: {
    left: "5px",
    top: "30px",
    width: "17px",
    height: "17px",
    position: "relative",
    verticalAlign: "middle",
    cursor: "pointer",
    color: "#3E8FC6",
  },
}));
const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.1rem;
  font-weight: 400;

`;
const HelpLine = styled.p`
  text-align : left;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

function AutomationStartDialog(props) {
  const { closeModal, refetch, automation, fullpoints, schedulesData, scriptData } = props;

  const [datebegin, setDatebegin] = useState(automation.event?.begin || moment().format("YYYY-MM-DDTHH:mm"));
  const [dateend, setDateend] = useState(automation.event?.end || moment().add(1, 'day').format("YYYY-MM-DDTHH:mm"));
  const [automationtype, setAutomationtype] = useState(automation.parameters.automationtype || "derogation");
  const [actions, setActions] = useState(automation?.parameters.actions || []);

  const [alert, setAlert] = React.useState(null);

  const [buttonDisabled, setButtonDisabled] = useState(false);

  useEffect(() => {
    actions.forEach((action) => {
      action.val = action.defaultval;
    });
  }, []);


  const handleDatebeginChange = (event) => {
    let newdatebegin = event.target.value;
    // if (moment(newdatebegin).isAfter(moment(dateend)))
    //   setDateend(newdatebegin);
    setDatebegin(newdatebegin);
  };
  const handleDateendChange = (event) => {
    let newdateend = event.target.value;
    // if (moment(newdateend).isBefore(moment(datebegin)))
    //   setDatebegin(newdateend);
    setDateend(newdateend);
  };

  useEffect(() => {
    let disabled = true;
    if (automationtype === 'derogation' && datebegin && dateend) {
      if (moment(dateend).isAfter(moment(datebegin)))
        disabled = false;
    }
    else if (automationtype === 'controlrule') {
      disabled = false;
    }
    setButtonDisabled(disabled);
  }, [datebegin, dateend, automationtype]);


  const handleValChange = (event, action) => {
    action.val = event.target.value;
    let newactions = [...actions];
    let actionmodif = newactions.find((o) => o.uuid === action.uuid);
    actionmodif.val = event.target.value;
    setActions(newactions);
  };

  const handleScheduleChange = (selected, action) => {
    action.schedule = selected?.id || "";
    let newactions = [...actions];
    let actionmodif = newactions.find((o) => o.uuid === action.uuid);
    actionmodif.schedule = selected?.id || "";
    setActions(newactions);
  };

  const handleScriptChange = (selected, action) => {
    action.script = selected?.id || "";
    let newactions = [...actions];
    let actionmodif = newactions.find((o) => o.uuid === action.uuid);
    actionmodif.script = selected?.id || "";
    setActions(newactions);
  };


  const handleFormulaChange = (event, action) => {
    action.formula = event.target.value;
    let newactions = [...actions];
    let actionmodif = newactions.find((o) => o.uuid === action.uuid);
    actionmodif.formula = event.target.value;
    setActions(newactions);
  };


  const selectedSchedule = (schedule) => {
    let selected = schedulesData.find((obj) => obj.id == schedule);
    if (!selected)
      selected = "";
    return selected;
  };
  const selectedScript = (script) => {
    let selected = scriptData.find((obj) => obj.id == script);
    if (!selected)
      selected = "";
    return selected;
  };


  const classes = useStyles();
  const hideAlert = () => {
    setAlert(null);
  };
  const getTooltipHelp = () => {
    const tooltipAlert = (
      <SweetAlert
        style={{
          fontSize: '14px',
          fontFamily: '"Source Sans Pro",sans-serif',
          color: ' #3c4858',
          display: "block", marginTop: "-50px", width: "25rem"
        }}
        title=""
        showConfirm={false}
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
      >
        <div style={{ fontSize: "14px" }}>
          <p><b>Fonctions de la formule :</b></p>
          <HelpLine>{"{schedule} : la valeur du planning sur le créneau horaire"}</HelpLine>
          <HelpLine>{"{state} : la valeur actuelle du point piloté"}</HelpLine>
          <HelpLine>{"{AVG[points]} : la moyenne des valeurs des points liés"}</HelpLine>
          <HelpLine>{"{SUM[points]} : la somme des valeurs des points liés"}</HelpLine>
          <HelpLine>{"{MIN[points]} : le plus petite des valeurs des points liés"}</HelpLine>
          <HelpLine>{"{MAX[points]} : la plus grande des valeurs des points liés"}</HelpLine>
        </div>
      </SweetAlert>
    );
    setAlert(tooltipAlert);
  };

  const handleSubmit = (event) => {
    updateAutomation(event);
    closeModal();
  };

  const updateAutomation = async (event) => {
    let automationevent = {
      ...automation.parameters
    }
    automationevent.date = moment();
    if (automationtype === 'derogation') {
      automationevent.begin = datebegin;
      automationevent.end = dateend;
    }
    axios
      .put(
        putGEBAutomation(automation.id, "start"),
        automationevent,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success(automationText.automationstarted);
          refetch();
        } else NotificationManager.error("Une erreur est survenue");
      })
      .catch((error) => {
        NotificationManager.error("Une erreur est survenue");
        // setLoading(false);
      });
  };

  const actionsColumns = [
    {
      name: automationText.selectedequipments,
      selector: (row) => row.targetequipments.length,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.targetequipments.length,
    },
    {
      name: automationText.controltype,
      selector: (row) => row.controltype,
      sortable: true,
      // maxWidth: "10rem",
      cell: (row) => row.controltype ? controltypeData.find((a) => a.id == row.controltype)?.name || "" : ""
    },
  ]

  const ExpandableComponent = (props) => {
    const { data } = props;
    let action = actions.find((o) => o.uuid === data.uuid);
    let targetequipments = action.targetequipments;
    let controltype = action.controltype;
    let controltypedatatype = action.controltypedatatype;
    let forcesaver = action.forcesaver;
    let controlmode = action.controlmode;
    let changeschedule = action.changeschedule;
    let schedule = action.schedule;
    let script = action.script;
    let changeformula = action.changeformula;
    let formula = action.formula;
    let val = action.val;
    let availablecontroltype = action.availablecontroltype;
    let controltypedef = controltypeData.find((ctrl) => ctrl.id === controltype);
    let availablemodes = [];
    if (controltypedef && controltypedef.type === 'list') {
      let firstpt = true;
      targetequipments.forEach((eq) => {
        let eqpoints = fullpoints.filter((p) => p.equipment == eq.id && p.controlproperties?.controls && p.controlproperties.controltype === controltype);
        eqpoints.forEach((pt) => {
          if (firstpt) {
            availablemodes = [...pt.controlproperties.controls];
            firstpt = false;
          }
          else {
            let newavailablemodes = [...pt.controlproperties.controls];
            availablemodes = availablemodes.filter((mode) =>
              newavailablemodes.some((newmode) => mode.id === newmode.id));
          }
        });

      }
      );
      availablemodes.forEach((mode) => {
        mode.name = controllistData.find((cl) => cl.id === mode.id)?.name || "Mode non reconnu";
      });
    }

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12} lg={12} style={{ marginBottom: '1rem' }}>
        {controlmode === 1 ?
          <>
            {changeschedule ?
              <div>
                <AutocompleteInputMeters
                  specialWidth={"97%"}
                  inputMargin={"1rem 0rem 0rem"}
                  inputTitle={"Planning"}
                  selected={selectedSchedule(schedule)}
                  list={schedulesData}
                  handleChange={(_, newValue) =>
                    handleScheduleChange(newValue, action)
                  }
                />
              </div> : <></>
            }
            {changeformula ?
              <div>
                <GridContainer>
                  <GridItem xs={11} sm={11} md={11} lg={11} className={"noPadding"}>
                    <TextInputUn
                      inputTitle={"Formule"}
                      textInput={formula}
                      handleTextInputChange={(event) => handleFormulaChange(event, action)}
                      multiline
                      rows={4}
                    />
                  </GridItem>
                  <GridItem xs={1} sm={1} md={1} lg={1}>
                    <HelpIcon className={classes.icon} onClick={() => getTooltipHelp()} />
                  </GridItem>
                </GridContainer>
              </div> : <></>
            }

          </>
          : controlmode === 0 ?
            <>
              {
                (controltypedef && controltypedef.type === 'int') ?
                  <IntInputUn
                    inputTitle={automationText.automationval}
                    intInput={val}
                    handleIntInputChange={(event) => handleValChange(event, action)}
                  /> : (controltypedef && controltypedef.type === 'list') ? <CustomSelect
                    inputTitle={automationText.automationval}
                    selectValue={val}
                    handleSelectValueChange={(event) => handleValChange(event, action)}
                    data={availablemodes}
                  /> : <></>
              }
            </> : controlmode === 2 ?
              <>
                <div>
                  <AutocompleteInputMeters
                    specialWidth={"97%"}
                    inputMargin={"1rem 0rem 0rem"}
                    inputTitle={"Script"}
                    selected={selectedScript(script)}
                    list={scriptData}
                    handleChange={(_, newValue) =>
                      handleScriptChange(newValue, action)
                    }
                  />
                </div>
              </> :
              <></>
        }
      </GridItem>
      <div style={{ height: "1.1rem" }}></div>
    </GridContainer >);
};

const [resetPaginationToggleChart, setResetPaginationToggleChart] = useState(false);
const subHeaderComponentMemoChart = useMemo(() => {
  const handleClearChart = () => {
  };
  return (
    <>
      <TableName>Actions</TableName>
    </>
  );
}, [actions]);

return (
  <>

    <form className={classes.root}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          {
            automationtype === 'derogation' ?
              <>
                <DateTimeInput
                  inputTitle={automationText.automationdatebegin}
                  dateInput={datebegin}
                  handleDateInputChange={handleDatebeginChange}
                  isRequired={true}
                />
                <DateTimeInput
                  inputTitle={automationText.automationdateend}
                  dateInput={dateend}
                  handleDateInputChange={handleDateendChange}
                  isRequired={true}
                />
              </>
              : <></>
          }
          <>
            <DataTable
              noDataComponent={<NoData>{"Aucune action"}</NoData>}
              noHeader={true}
              columns={actionsColumns}
              persistTableHead
              subHeader
              data={actions}
              pagination={false}
              manual={true}
              subHeaderComponent={subHeaderComponentMemoChart}
              expandOnRowClicked
              expandableRows
              expandableRowDisabled={(row) => row.disabled}
              expandableRowsComponent={ExpandableComponent}
            />
          </>
          <Button
            disabled={buttonDisabled}
            className={
              buttonDisabled
                ? classes.submitButtonDisabled
                : classes.submitButton
            }
            onClick={() => {
              handleSubmit();
            }}
          >
            Enregistrer
          </Button>


        </GridItem>
      </GridContainer>
    </form>
    {alert}
  </>
);
}

export default AutomationStartDialog;
